<template>
    <div class="ppv2-relative ppv2-inline-block" ref="dropdown">
        <!-- Trigger -->
        <div @click="toggle">
            <slot name="trigger" />
        </div>

        <transition name="fade">
            <div
                v-if="isOpen"
                ref="menu"
                class="ppv2-absolute ppv2-z-[9999] ppv2-overflow-hidden ppv2-w-64 ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-xl ppv2-shadow-2xl ppv2-border ppv2-border-gray-100"
                :style="positionStyle"
            >
                <button
                    v-for="(item, index) in items"
                    :key="index"
                    @click="handleClick(item)"
                    :disabled="item.disabled"
                    class="ppv2-w-full ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-3 ppv2-text-left ppv2-transition-colors"
                    :class="[
                        item.disabled ? 'ppv2-text-gray-300 ppv2-cursor-not-allowed' : 'hover:ppv2-bg-[#7D2DBD1A]',
                        item.danger ? 'ppv2-text-red-500' : 'ppv2-text-black ppv2-bg-opacity-70',
                    ]"
                >
                    <component :is="item.icon" :size="18" />
                    <span class="ppv2-text-sm">
                        {{ item.label }}
                    </span>
                </button>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isOpen: false,
            positionStyle: {
                top: '0px',
                left: '0px',
            },
        }
    },

    mounted() {
        document.addEventListener('click', this.handleOutside)
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleOutside)
    },

    methods: {
        toggle() {
            this.isOpen = !this.isOpen
            this.$emit('toggle', this.isOpen)

            if (this.isOpen) {
                this.$nextTick(() => {
                    const rect = this.$refs.dropdown.getBoundingClientRect()

                    this.positionStyle = {
                        top: rect.height + 'px', // directly under trigger
                        left: '0px', // align left of wrapper
                    }
                })
            }
        },
        handleClick(item) {
            if (item.disabled) return

            this.isOpen = false
            this.$emit('toggle', false)
            this.$emit('select', item)

            this.$nextTick(() => {
                item.action?.()
            })
        },

        handleOutside(event) {
            if (!this.$refs.dropdown?.contains(event.target)) {
                if (this.isOpen) {
                    this.isOpen = false
                    this.$emit('toggle', false)
                }
            }
        },
    },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
